<template>
  <section class="l__wrapper b__nudge--bottom-huge b__nudge--top-large">
    <article class="b__nudge--bottom">
      <router-view/>
    </article>
    <header class="l__wrapper--slim space--20-30">
      <p class="text--gray b__nudge--bottom">
        <strong>{{ $t('trending') }}</strong>: {{ $t('trendingdescription') }}
      </p>
    </header>
  </section>
</template>
<script>

export default {
  name: 'Home'
}
</script>

<style>
@import './assets/css/styles.min.css';

.bg-up {
  background-color: var(--bs-green);
}

/* START shame */
.nav-dropdown p {
  margin-bottom: inherit !important;
}

.text--logo img {
  vertical-align: inherit !important;
}

.nav-dropdown__item {
  top: inherit !important;
}
/* END shame */

.color-up {
  color: var(--bs-green)
}

.bg-down {
  background-color: var(--bs-red);
}

.color-down {
  color: var(--bs-red)
}

.d-ticker-card-title {
  width: 270px;
}
</style>
